import { FC, useMemo, useCallback } from 'react'
import { AdvisorRequestPanePreset } from 'components/features/coaching/advisorMeeting/AdvisorRequestPanePreset/AdvisorRequestPanePreset'
import styles from 'components/features/coaching/advisorMeeting/AdvisorRequestLoading/AdvisorRequestLoading.styl'
import { CancelAdvisorsRequestAction } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { AdvisorRequestSpinners } from 'components/features/coaching/advisorMeeting/AdvisorRequestSpinners/AdvisorRequestSpinners'
import Spinner from 'components/features/pfm/Spinner/Spinner'

type AdvisorRequestLoadingProps = {
  type: 'search' | 'booking'
  progressBarPercent?: number
  onClose: () => void
}
export const AdvisorRequestLoading: FC<AdvisorRequestLoadingProps> = (props) => {
  const { type, onClose, progressBarPercent } = props

  const contentChild = useMemo(() => type === 'search' ? (
    <AdvisorRequestSpinners />
  ) : (
    <div className={ styles.centeredSpinner }>
      <Spinner size='normal' />
      <div>Confirming your call...</div>
    </div>
  ), [type])

  const dispatch = useStoreDispatch()
  const handleCancel = useCallback(() => {
    dispatch(new CancelAdvisorsRequestAction())
    onClose()
  }, [onClose, dispatch])

  return (
    <AdvisorRequestPanePreset
      title='Schedule a New Coaching Session'
      subTitle={ type === 'search' ? 'Finding the perfect coach...' : 'Confirming...' }
      progressBarPercent={ progressBarPercent }
      onCancel={ handleCancel }
    >
      <div className={ styles.module }>
        { contentChild }
      </div>
    </AdvisorRequestPanePreset>
  )
}
